<template>

                    <div class="popup loc__popup">
                        <i class="popup__close arcticmodal-close"></i>
                        <div class="loc">
                            <div
                                class="loc__header"
                                :class="loading ? 'right' : ''"
                            >
                                <div class="loc__title" v-if="!loading">Выберите город</div>
                                <button class="loc__close" @click="close"></button>
                            </div>
                            <Loader v-if="loading" size="md" class="center-vertical"/>
                            <div
                                class="loc__body"
                                v-else
                            >
                                <div class="input">
                                    <input
                                        class="input__field loc__field js-filter-location-input"
                                        type="text"
                                        placeholder="Москва"
                                        v-model="query"
                                    >
                                    <button
                                        class="loc__del"
                                        style="display: block"
                                        v-if="query"
                                        @click="query = ''"
                                    ></button>
                                </div>
                                <div
                                    class="loc__err"
                                    style="display: block"
                                    v-if="query && filteredBranches.length === 0"
                                >
                                    Город не&nbsp;найден. Свяжитесь с&nbsp;нами по&nbsp;тел.:
                                    <a href="">8&nbsp;800&nbsp;555-55-22</a>
                                </div>
                                <div
                                    class="loc__list"
                                    style="display: block"
                                    v-if="query"
                                >
                                    <div class="loc__inner">
                                        <div
                                            class="loc__city"
                                            :key="branch.key"
                                            v-for="branch in filteredBranches"
                                            @click.prevent="selectBranch(branch)"
                                            v-html="highlightQuery(branch.name)"
                                        ></div>
                                    </div>
                                </div>
                                <div class="loc__auto" style="display: none;">
                                    Автоопределение:
                                </div>
                                <div
                                    class="loc__main"
                                    v-if="!query"
                                >
                                    <div
                                        class="loc__btn"
                                        :key="branch.key"
                                        v-for="branch in popularInSearch"
                                        @click.prevent="selectBranch(branch)"
                                    >{{ branch.name }}</div>
                                </div>
                                <div
                                    class="loc__all"
                                    v-if="!query && filteredBranches.length > 0"
                                >
                                    <div class="loc__inner">
                                        <div
                                            class="loc__group"
                                            v-for="(data, index) in filteredBranches"
                                            :key="'group-' + index"
                                        >
                                            <div class="loc__letter">{{ capitalizeFirstLetter(data.letter) }}</div>
                                            <div
                                                class="loc__name"
                                                v-for="branch in data.branches"
                                                :key="branch.key"
                                                @click.prevent="selectBranch(branch)"
                                            >
                                                {{ branch.name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
</template>

<script>
import Loader from '../../../components/ui/Loader.vue';

export default {
    name: "SelectBranchModal",
    components: {
        Loader
    },
    props: {
        selectedBranches: {
            type: Array
        },
        loadBranchesFunction: {
            type: Function
        },
        selectBranchFunction: {
            type: Function
        },
    },
    data() {
        return {
            loading: false,
            branches: null,
            query: null,
            en: 'qwertyuiopasdfghjklzxcvbnm',
            ru: 'йцукенгшщзфывапролдячсмить',
            replaceEnRegExp: null,
        }
    },
    computed: {
        selectedKey () {
            let grouped = {};
            if (!Array.isArray(this.selectedBranches)) {
                return grouped;
            }

            this.selectedBranches.forEach(branch => {
                grouped[branch.key] = true;
            })

            return grouped;
        },
        displayBranches () {
            if (!Array.isArray(this.branches)) return [];
            return this.branches.filter(branch => !this.selectedKey[branch.key]);
        },
        popularInSearch() {
            return this.displayBranches
                .filter(branch => branch.popularInSearch)
                .sort((a, b) => a.sort - b.sort);
        },
        filteredBranches () {
            if (!this.query) {
                return this.getWithAlphabet(this.displayBranches);
            }

            let queryReplaced = this.replaceEnChars(this.query.toLowerCase());
            let regexp;

            try {
                regexp = new RegExp(queryReplaced, 'i');
            } catch (e) {
                return [];
            }

            return this.addIndexToElements(this.displayBranches.filter(branch => regexp.test(branch.name)), queryReplaced)
                .sort((a, b) => a.index - b.index);
        },
    },
    mounted () {
        this.loading = true;
        this.loadBranchesFunction()
            .then((branches) => {
                this.branches = branches.map(branch => {
                    if (branch.name === '8800') {
                        return { ...branch, name: '8-800 Федеральные' };
                    }
                    return branch;
                });
                this.replaceEnRegExp = new RegExp(`[${this.en}]`, 'i');
                this.loading = false;
            })
            .catch(() => {
                this.loading = false;
            })
    },
    methods: {
        close() {
            this.$emit('close');
        },
        selectBranch (branch) {
            this.selectBranchFunction(branch);
            this.close();
        },
        getWithAlphabet (branches) {
            let flat = {};
            branches.forEach(branch => {
                let letter = Array.from(branch.name)[0];

                if (
                    branch.name === '8-800 Федеральные'
                    || branch.name === 'Мобильные номера'
                ) {
                    letter = 'Вся Россия';
                }

                if (!flat[letter]) {
                    flat[letter] = {
                        'letter': letter,
                        'branches': []
                    };
                }

                flat[letter]['branches'].push(branch);
            });

            return this.keysToNumbers(flat, 'Вся Россия');
        },
        keysToNumbers (object, firstKey) {
            let newObj = [];

            if (object[firstKey]) {
                // Добавляем в самое начало "Вся Россия"
                newObj = [
                    {
                        letter: object[firstKey].letter,
                        branches: object[firstKey].branches
                    }
                ];
                delete object[firstKey];
            }

            for (let index in object) {
                if (object[index].branches.length === 0) {
                    continue;
                }

                newObj.push(object[index]);
            }

            return newObj;
        },
        replaceEnChars (value) {
            // Проверка на наличие латинских букв в строке. Если их нет, возвращаем оригинальное значение
            if (this.replaceEnRegExp && !this.replaceEnRegExp.test(value)) {
                return value;
            }

            for (let i = 0; i < value.length; i++) {
                let index = this.en.indexOf(value[i]);
                if (this.en.indexOf(value[i]) !== -1) {
                    value = value.replace(this.en[index], this.ru[index]);
                }
            }

            return value;
        },
        capitalizeFirstLetter (value) {
            return String(value).charAt(0).toUpperCase() + String(value).slice(1);

        },
        highlightQuery (branchName) {
            if (this.query.length === 0) {
                return branchName;
            }

            let query = this.replaceEnChars(this.query.toLowerCase());
            let escapedQuery = this.replaceEnChars(query.toLowerCase()).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            let regexp = new RegExp(`(${escapedQuery})`, 'i');
            let parts = branchName.split(regexp);

            let firstNonEmptyIndex = parts.findIndex(part => part !== '');
            if (firstNonEmptyIndex !== -1) {
                let firstPart = parts[firstNonEmptyIndex];
                parts[firstNonEmptyIndex] = firstPart.charAt(0).toUpperCase() + firstPart.slice(1);
            }

            return parts.map((part, index) => {
                return index % 2 === 1
                    ? `<mark class="loc__bold">${part}</mark>`
                    : `<span>${part}</span>`;
            }).join('');
        },
        addIndexToElements (elements, query) {
            for (let index in elements) {
                elements[index]['index'] = elements[index].name.toLowerCase().indexOf(query);
            }

            return elements;
        }
    }
}
</script>

<style lang="scss">
.select-branch-modal .input {
    position: relative;
}
</style>